export const INTERVIEW_FEEDBACK_MODEL = "interview-feedback";
import { INTERVIEW_PARTICIPANT_MODEL } from "@/models/interview-participant-model";
import { INTERVIEW_SLOT_MODEL } from "@/models/interview-slot-model";
import { INTERVIEW_FEEDBACK_SCORE_MODEL } from "@/models/interview-feedback-score-model";

const interviewFeedbackModel = {
  averageScore: 0,
  totalScore: 0,
  file: "",
  internalNotes: "",
  candidateFeedback: "",
  interviewer: {
    jsonApi: "hasOne",
    type: INTERVIEW_PARTICIPANT_MODEL
  },
  scoresToAdd: [],
  scores: {
    jsonApi: "hasMany",
    type: INTERVIEW_FEEDBACK_SCORE_MODEL
  },
  interviewSlot: {
    jsonApi: "hasOne",
    type: INTERVIEW_SLOT_MODEL
  }
};

export default interviewFeedbackModel;
